// SEO landing page configuration
import { buildCitySeoEntries } from './cityData';

const STATIC_SEO_PAGES = {
  'pendelkostenrechner': {
    slug: 'pendelkostenrechner',
    h1: 'Pendelkostenrechner',
    headline: 'Was kostet dich dein Arbeitsweg wirklich?',
    intro: 'Berechne in 30 Sekunden deine realen Pendelkosten — Sprit, Verschleiß und Lebenszeit inklusive. Kostenlos, ohne Anmeldung.',
    meta_title: 'Pendelkostenrechner 2026: Was der Arbeitsweg dich WIRKLICH kostet',
    meta_description: '⚡ Pendelkosten in 30 Sek ehrlich berechnen: Sprit + Verschleiß + Lebenszeit. Live-Spritpreise, Pendlerpauschale & Smart-Empfehlungen. Kostenlos, ohne Anmeldung.',
    keyword: 'Pendelkostenrechner',
    variant: 'pendelkosten',
    preset: 'mittel',
  },
  'fahrtkostenrechner-arbeit': {
    slug: 'fahrtkostenrechner-arbeit',
    h1: 'Fahrtkostenrechner Arbeit',
    headline: 'Fahrtkosten zur Arbeit ehrlich berechnen.',
    intro: 'Ermittle pro Monat und Jahr, wie viel dich der Weg zur Arbeit tatsächlich kostet — und welche Alternativen sich rechnen.',
    meta_title: 'Fahrtkostenrechner Arbeit: Kosten pro Monat & Jahr | PendelPilot',
    meta_description: 'Fahrtkostenrechner für den Arbeitsweg. Berechne Pendelkosten ehrlich inkl. Verschleiß, Sprit & Pendlerpauschale. Konkrete Spar-Empfehlungen inklusive.',
    keyword: 'Fahrtkostenrechner Arbeit',
    variant: 'pendelkosten',
    preset: 'mittel',
  },
  'jobwechsel-rechner': {
    slug: 'jobwechsel-rechner',
    h1: 'Jobwechsel-Rechner',
    headline: 'Lohnt sich dein Jobwechsel wirklich?',
    intro: 'Vergleiche dein neues Gehalt mit den zusätzlichen Pendelkosten — und sieh sofort, wie viel netto bei dir wirklich ankommt.',
    meta_title: 'Jobwechsel-Rechner: Lohnt sich der neue Job wirklich? (2026)',
    meta_description: '⚡ Neuer Job = mehr Netto oder frisst Pendelweg alles auf? Vergleich in 30 Sek: aktuelles vs. neues Gehalt minus Pendelkosten. Klares Fazit inklusive.',
    keyword: 'Jobwechsel Rechner',
    showJobSwitch: true,
    variant: 'jobwechsel',
    preset: 'mittel',
  },
  'arbeitsweg-kosten-berechnen': {
    slug: 'arbeitsweg-kosten-berechnen',
    h1: 'Arbeitsweg-Kosten berechnen',
    headline: 'Wie viel zahlst du wirklich für deinen Arbeitsweg?',
    intro: 'In 30 Sekunden zur ehrlichen Antwort. Inklusive Spritpreis-Automatik, Pendlerpauschale und konkreten Handlungsempfehlungen.',
    meta_title: 'Arbeitsweg Kosten berechnen — kostenlos & ohne Anmeldung',
    meta_description: 'Arbeitsweg-Kosten online berechnen. Inkl. Spritpreis, Verschleiß, Lebenszeit und Pendlerpauschale. Sofort konkrete Empfehlungen.',
    keyword: 'Arbeitsweg Kosten berechnen',
    variant: 'pendelkosten',
    preset: 'mittel',
  },
  'auto-finanzieren-rechner': {
    slug: 'auto-finanzieren-rechner',
    h1: 'Auto-Finanzieren-Rechner für Pendler',
    headline: 'Welches Auto kannst du dir leisten — beim Pendeln?',
    intro: 'Berechne ehrlich, was dein Pendel-Auto inkl. Sprit, Verschleiß und Wertverlust pro Monat kostet — bevor du finanzierst.',
    meta_title: 'Auto finanzieren Rechner für Pendler | PendelPilot',
    meta_description: 'Auto finanzieren als Pendler? Berechne reale Monatskosten inkl. Sprit, Verschleiß & Pendelweg. Ehrliche Entscheidungsgrundlage.',
    keyword: 'Auto finanzieren Rechner',
    variant: 'autofinanzierung',
    preset: 'lang',
  },
  'pendeln-kosten-pro-monat': {
    slug: 'pendeln-kosten-pro-monat',
    h1: 'Pendeln: Kosten pro Monat',
    headline: 'Was kostet Pendeln im Monat?',
    intro: 'Sofort sichtbar: monatliche Sprit-, Verschleiß- und Zeit-Kosten deines Arbeitswegs. Plus: was du wirklich sparen kannst.',
    meta_title: 'Pendeln Kosten pro Monat — Rechner & Übersicht | PendelPilot',
    meta_description: 'Wie viel kostet Pendeln pro Monat? Online-Rechner mit ehrlichen Kosten, Pendlerpauschale und Spar-Empfehlungen. Kostenlos.',
    keyword: 'Pendeln Kosten pro Monat',
    variant: 'monatskosten',
    preset: 'mittel',
  },
  'homeoffice-rechner': {
    slug: 'homeoffice-rechner',
    h1: 'Homeoffice-Rechner',
    headline: 'Wie viel sparst du mit Homeoffice?',
    intro: 'Sieh sofort, wie viel Geld und Lebenszeit dir jeder Homeoffice-Tag pro Woche bringt — basierend auf deinem echten Arbeitsweg.',
    meta_title: 'Homeoffice-Rechner: So viel sparst du pro Tag (€ + Stunden)',
    meta_description: '⚡ Wie viel Geld & Lebenszeit spart dir 1 Tag Homeoffice pro Woche? Sofort berechnen basierend auf deinem echten Arbeitsweg. Für die Chef-Verhandlung.',
    keyword: 'Homeoffice Rechner',
    variant: 'homeoffice',
    preset: 'mittel',
  },
  'pendlerpauschale-rechner': {
    slug: 'pendlerpauschale-rechner',
    h1: 'Pendlerpauschale-Rechner 2025',
    headline: 'Pendlerpauschale 2025 berechnen.',
    intro: 'Wie viel Pendlerpauschale steht dir zu? 0,30 €/km bis 20 km, 0,38 €/km ab km 21. Sofort ausgerechnet — inklusive Jahreswert.',
    meta_title: 'Pendlerpauschale 2026 berechnen: So viel bekommst du zurück',
    meta_description: '⚡ Pendlerpauschale 2026 in 30 Sek berechnen: 0,30 €/km bis 20 km, 0,38 €/km ab km 21. Zeigt sofort deine Jahressumme + geschätzte Steuerersparnis. Kostenlos.',
    keyword: 'Pendlerpauschale Rechner',
    variant: 'pauschale',
    preset: 'mittel',
  },
};

// Merge static SEO pages with the auto-generated city pages.
export const SEO_PAGES = { ...STATIC_SEO_PAGES, ...buildCitySeoEntries() };

export const SEO_LIST = Object.values(SEO_PAGES);
export const CITY_SLUGS = Object.keys(SEO_PAGES).filter((k) => k.startsWith('pendelkosten-'));
export const TOP_LEVEL_SEO_LIST = Object.values(STATIC_SEO_PAGES);

// 3 prominenteste Rechner — gezeigt im Header und in der Haupt-Übersicht.
// Andere SEO-Routen bleiben für Suchmaschinen weiterhin erreichbar.
export const FEATURED_SEO_SLUGS = [
  'pendelkostenrechner',
  'homeoffice-rechner',
  'jobwechsel-rechner',
];
export const FEATURED_SEO_LIST = FEATURED_SEO_SLUGS.map((s) => SEO_PAGES[s]);
